const firebaseConfig = {
  apiKey: "AIzaSyDKSBpc7_wEx-XdLY1bTlBrrjjLorc2ZMY",
  authDomain: "creative-agency-73697.firebaseapp.com",
  databaseURL: "https://creative-agency-73697.firebaseio.com",
  projectId: "creative-agency-73697",
  storageBucket: "creative-agency-73697.appspot.com",
  messagingSenderId: "227635788004",
  appId: "1:227635788004:web:137f208f0325d03d7ed4f1"
};


  export default firebaseConfig;